/**
 * 4.3.9 walkthrough slides.
 *
 * Each slide:
 *   {
 *     image:          public-path string (e.g. '/walkthroughs/4.3.9/foo.png'),
 *     title:          short heading,
 *     body:           one or two sentences describing the change,
 *     minRoleWeight?: integer — only users with role_weight >= this see the slide
 *                     (matches hasMinRole gating; omit for "visible to everyone")
 *     is_cloud_only?: boolean — true hides the slide on 4.0 campuses, for features
 *                     that only exist on the 5.0 cloud architecture. Omitted or
 *                     false means architecture-independent. Evaluated against the
 *                     campus config's `is_cloud` in collectSlides (index.js).
 *   }
 *
 * Drop walkthrough images under public/walkthroughs/{version}/.
 */
export default [
  {
    image: '/walkthroughs/4.3.9/slide1.png',
    title: 'New Portal Design For All',
    body: 'The new Portal design is now the only design, and Classic mode has been retired. If you were still using Classic, everything you rely on is here, with a cleaner layout, easier navigation, and every new feature in this release. If something feels unfamiliar, the Help button in the menu can walk you through the most common tasks, and our support team is always happy to help at support@palcare.com or 888-725-2848.',
    minRoleName: "Everyone",
    minRoleWeight: 0,
    is_cloud_only: false
  },{
    image: '/walkthroughs/4.3.9/slide2.png',
    title: 'New Caregiver Report',
    body: 'A new Caregiver report shows how each caregiver is responding to alerts. For every caregiver you can see how many alerts they handled, their average response and service times, and the reasons they recorded. Run it any time or schedule it to arrive by email, so your teams can recognize strong performers and see where extra support or training would help.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false
  },{
    image: '/walkthroughs/4.3.9/slide3.png',
    title: 'Viewable ADT Logging',
    body: 'Resident, area, and device profiles now include a Logs tab that shows what changed and when. Move-ins, room moves, device assignments (with the device name and serial number), and edits such as a new phone number are recorded with the before and after values. You will start seeing new changes appear there going forward, giving your teams a clear history when questions come up.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false
  },{
    image: '/walkthroughs/4.3.9/slide4.png',
    title: 'System Outage Alert & Banner',
    body: `If your community's system stops checking in and appears to be offline, Portal now raises a System Outage alert and shows a banner across the top of every page. The alert can be routed through Alert Careflow like any other alert, so the right people know right away and the issue can be addressed before it affects care.`,
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: true
  },{
    image: '/walkthroughs/4.3.9/slide5.png',
    title: 'Light/Dark Mode',
    body: 'Prefer a darker screen, especially during night shifts? Use the light and dark mode toggle in the navigation menu to switch between the two any time. Your choice is remembered on that device.',
    minRoleName: "Everyone",
    minRoleWeight: 0,
    is_cloud_only: false
  }
];